import appState from "../state/app.state";

const omitAccessToken = (user) => {
  const next = { ...user };
  delete next.access_token;
  return next;
};

export const persistUser = (user) => {
  localStorage.setItem("User", JSON.stringify(omitAccessToken(user)));
};

export const restoreSessionToken = (encodedAt, encodedK) =>
  appState.d(encodedAt) + appState.rk(appState.d(encodedK));

export const getSessionToken = () => {
  const encodedAt = localStorage.getItem("at");
  const encodedK = localStorage.getItem("k");

  if (!encodedAt || !encodedK) {
    return null;
  }

  try {
    return restoreSessionToken(encodedAt, encodedK);
  } catch {
    return null;
  }
};

export const getStoredUser = () => {
  const value = localStorage.getItem("User");

  if (!value || value === "null" || value === "undefined") {
    return null;
  }

  try {
    const user = JSON.parse(value);
    if (!user || typeof user !== "object" || Array.isArray(user)) {
      return null;
    }

    if ("access_token" in user) {
      persistUser(user);
    }

    const stored = "access_token" in user ? omitAccessToken(user) : user;

    return {
      ...stored,
      permission: Array.isArray(stored.permission) ? stored.permission : [],
    };
  } catch {
    return null;
  }
};

export const clearAuthStorage = () => {
  localStorage.removeItem("User");
  localStorage.removeItem("at");
  localStorage.removeItem("k");
};
